import type { ColumnsType } from 'antd/lib/table'
import { ClickHereColumn, CustomHeaderText, CustomText, CustomTitle } from 'src/components'

const successOffsetsColumns: ColumnsType<any> = [
  {
    title: () => <CustomHeaderText text={'developers.OffSet.TransactionIdentifier'} />,
    responsive: ['sm'],
    render: (_, record) => {
      return (
        <span style={{ textAlign: 'center' }}>
          <strong>{record?.extra_data?.transaction_identifier}</strong>
        </span>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'developers.OffSet.Co2Amount'} />,
    responsive: ['sm'],
    render: (_, record) => {
      return (
        <span style={{ textAlign: 'center' }}>
          <strong>{record?.co2_amount}</strong>
        </span>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'developers.OffSet.Certificate'} />,
    responsive: ['sm'],
    render: (_, record) => {
      return (
        <ClickHereColumn url={record?.certificate} />
      )
    },
  },

  // Mobile View
  {
    title: () => <CustomHeaderText text={'developers.OffSet.TransactionIdentifier'} />,
    responsive: ['xs'],
    render: (_, record) => {
      return <>
        <CustomTitle label={record?.extra_data?.transaction_identifier} /> <br />
        <CustomText label={record?.co2_amount} />
        <ClickHereColumn url={record?.certificate} />
      </>
    },
  },
]

export default successOffsetsColumns
